module.exports = __webpack_public_path__ + "static/media/18ECA8.6cdf2f5c.jpg";